import React, {useState} from 'react';
import {useStyles} from './TransactionsTab.utils';
import {TransactionItem} from '../../../../store/actions/accounts/payloads';
import TransactionsContent from '../../../../components/Accounts/TransactionsContent';
import TransactionDetailsDialog from './TransactionDetailsDialog';

interface TransactionsTabProps {
    iAccount: number;
}

const TransactionsTab: React.VFC<TransactionsTabProps> = ({iAccount}) => {
    const classes = useStyles();

    const [selectedTransaction, setSelectedTransaction] = useState<TransactionItem | null>(null);

    return (
        <div className={classes.container}>
            <TransactionsContent
                iAccount={iAccount}
                onClickDetails={(item) => setSelectedTransaction(item)}
                filtersClassName={classes.filtersRow}
                tableClassName={classes.tableContainer}
            />

            <TransactionDetailsDialog
                selectedTransaction={selectedTransaction}
                onClose={() => setSelectedTransaction(null)}
            />
        </div>
    );
};

export default TransactionsTab;